export default {
  init() {
    // JavaScript to be fired on all pages
    $('.header .language-switcher.dropdown').hover(
      function () {
        $(this).addClass('show');
        $(this).children('.dropdown-menu').addClass('show');
        $(this).children('.dropdown-toggle').attr('aria-expanded', 'true');
      },
      function () {
        $(this).removeClass('show');
        $(this).children('.dropdown-menu').removeClass('show');
        $(this).children('.dropdown-toggle').attr('aria-expanded', 'false');
      });

    var checkScroll = function () {
      $('.header').toggleClass('scrolled', $(this).scrollTop() > 60);
    }
    $(window).on('load resize scroll', checkScroll);

    $(document).on('click', 'a[href^="#"]', function (event) {
      event.preventDefault();

      $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top,
      }, 200);
    });

    // Set offset for anchor so it doesn't scroll too far.
    // Smooth scroll anchor
    $('a[href*="#"]:not([href="#"])').on('click', function () {
      var offset = -100; // <-- change the value here
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top + offset,
          }, 500);
          return false;
        }
      }
    });

    // Fade out container on close icon click
    $('#disclaimer .fa.fa-times').on('click', function () {
      $('#disclaimer').fadeOut('slow');
    });

    // var elements = document.getElementsByClassName('someclass');
    // for(var i = 0; i < elements.length; i++){
    //    elements[i].onclick = function(){window.alert(this.dataset.somevalue);};
    // }

    $('.tab-content:first-child').show();
    $('.tab-nav-link').on('click', function () {
      var var1 = $(this);
      var target = $(var1.data('target')); // get the target from data attribute
      var1.siblings().removeClass('current');
      target.siblings().css('display', 'none');
      var1.addClass('current');
      target.fadeIn('fast');

    });
    $('.tab-nav-link:first-child').trigger('click');

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js